<!-- src/routes/(app)/(authentication)/(signup)/login/+page.svelte -->

<script lang="ts">
	import { onMount } from 'svelte';
	import { goto } from '$app/navigation';
	import { enhance } from '$app/forms';
	import { afterNavigate } from '$app/navigation'; //
	import { fade } from 'svelte/transition';
	import Alert from '$lib/components/ui/Alert.svelte';
	import Button from '$lib/components/ui/Button.svelte';
	import Label from '$lib/components/ui/Label.svelte';
	import * as m from '$paraglide/messages';
	export let form;
	import { page } from '$app/stores';
	import EmailInput from '$lib/components/ui/EmailInput.svelte';
	import PasswordInput from '$lib/components/ui/PasswordInput.svelte';
	import { GoogleSolid } from 'flowbite-svelte-icons';
	import Close from '$lib/icons/Close.svelte';

	let redirect = $page.url.searchParams.has('redirect')
		? `&redirect=${$page.url.searchParams.get('redirect')}`
		: '';

	const handleLoginSuccess = () => {
		if (typeof window !== 'undefined' && window.dataLayer) {
			console.log('login_success');
			window.dataLayer.push({
				event: 'login_success'
			});
		}
	};

	// Track regular form login
	const enhanceLogin = () => {
		return async ({ result, update }) => {
			if (result.type === 'redirect') {
				handleLoginSuccess();
			}
			await update();
		};
	};

	// Track OAuth login success by checking URL parameters
	afterNavigate(() => {
		const searchParams = new URLSearchParams(window.location.search);
		if (searchParams.get('oauth_success') === 'true') {
			handleLoginSuccess();
		}
	});
</script>

<a class="absolute right-3 top-4 z-10 block text-primary-300 md:right-10" href="/">
	<Close class="h-8"></Close>
</a>
<main class="relative flex min-h-full flex-col items-center justify-between">
	<div class="w-full max-w-md">
		<h1 class="mb-8 text-3xl font-semibold">Login</h1>

		<form class="mb-8 flex flex-col items-center justify-center gap-4" method="POST">
			<Button
				type="submit"
				formaction="?/signinWithGoogle{redirect}&oauth_success=true"
				size="md"
				outline
				class="w-full"
			>
				<div class="flex w-full items-center justify-center gap-4">
					<GoogleSolid /> Continue with Google
				</div>
			</Button>

			<p class="mt-4 text-sm text-gray-300">or</p>
		</form>

		<form action="?/login{redirect}" method="POST" use:enhance={enhanceLogin} data-no-translate>
			<div class="mb-6">
				<Label for="password" class="text-gray-300">
					{m.email()}
				</Label>
				<EmailInput name="email" placeholder={m.email()} value={form?.email ?? ''} required />
			</div>

			<div class="mb-6">
				<Label for="password" class="text-gray-300">
					{m.password()}
				</Label>
				<PasswordInput name="password" placeholder={m.password()} required />
				<a href="/forgot" class="font-mundial-light text-xs text-gray-300 hover:text-white"
					>Forgot your password?</a
				>
			</div>

			<div class="mb-2 flex justify-center">
				<Button color="primary" type="submit" size="lg">Login</Button>
			</div>
		</form>

		{#if form?.message}
			<div transition:fade class="mt-6 w-full">
				<Alert level={form.success ? 'success' : 'info'}>{form.message}</Alert>
			</div>
		{/if}
	</div>

	<div class="mt-12 w-full max-w-md border-t border-gray-200 p-6">
		<p class="w-full text-center text-gray-300">
			{m.no_account_yet()}
			<a href="/register" class="underline-offset-6 border-gray-300 underline hover:text-white"
				>{m.create_account()}</a
			>
		</p>
	</div>
</main>

<style>
</style>
